// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-settings-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px;
}

.social-settings-container .page-header {
    margin-bottom: 32px;
}

.social-settings-container .back-link {
    display: inline-block;
    color: var(--text-secondary, #666);
    text-decoration: none;
    margin-bottom: 16px;
    font-size: 0.9rem;
}

.social-settings-container .back-link:hover {
    color: var(--primary-color, #7c3aed);
}

.social-settings-container h1 {
    margin: 0 0 8px 0;
    font-size: 2rem;
    color: var(--text-primary, #1a1a1a);
}

.social-settings-container .page-description {
    margin: 0;
    color: var(--text-secondary, #666);
    font-size: 1rem;
}

/* Social Accounts Grid */
.social-accounts-grid {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

/* Coming Soon Card */
.social-connection.coming-soon {
    background: var(--card-bg, #fff);
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    opacity: 0.7;
    position: relative;
}

.social-connection.coming-soon .section-header {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.social-connection.coming-soon .header-icon {
    font-size: 2.5rem;
    line-height: 1;
}

.social-connection.coming-soon .header-text h2 {
    margin: 0 0 8px 0;
    font-size: 1.5rem;
    color: var(--text-primary, #1a1a1a);
}

.social-connection.coming-soon .header-text .description {
    margin: 0;
    color: var(--text-secondary, #666);
    font-size: 0.95rem;
}

.coming-soon-badge {
    position: absolute;
    top: 24px;
    right: 24px;
    background: var(--bg-tertiary, #e5e7eb);
    color: var(--text-secondary, #666);
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 500;
}

/* No access fallback */
.social-no-access {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 48px 24px;
    background: #f8fafc;
    border: 1px dashed #cbd5e1;
    border-radius: 12px;
    text-align: center;
}

.social-no-access-icon {
    font-size: 2.4rem;
}

.social-no-access p {
    margin: 0;
    color: #64748b;
    font-size: 0.95rem;
    max-width: 420px;
    line-height: 1.5;
}

/* Responsive */
@media (max-width: 768px) {
    .social-settings-container {
        padding: 16px;
    }

    .social-settings-container h1 {
        font-size: 1.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/SocialSettings.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,SAAS;IACT,kCAAkC;IAClC,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,qBAAqB;AACrB;IACI,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,SAAS;IACT,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uCAAuC;IACvC,kCAAkC;IAClC,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".social-settings-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 24px;\n}\n\n.social-settings-container .page-header {\n    margin-bottom: 32px;\n}\n\n.social-settings-container .back-link {\n    display: inline-block;\n    color: var(--text-secondary, #666);\n    text-decoration: none;\n    margin-bottom: 16px;\n    font-size: 0.9rem;\n}\n\n.social-settings-container .back-link:hover {\n    color: var(--primary-color, #7c3aed);\n}\n\n.social-settings-container h1 {\n    margin: 0 0 8px 0;\n    font-size: 2rem;\n    color: var(--text-primary, #1a1a1a);\n}\n\n.social-settings-container .page-description {\n    margin: 0;\n    color: var(--text-secondary, #666);\n    font-size: 1rem;\n}\n\n/* Social Accounts Grid */\n.social-accounts-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n/* Coming Soon Card */\n.social-connection.coming-soon {\n    background: var(--card-bg, #fff);\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    opacity: 0.7;\n    position: relative;\n}\n\n.social-connection.coming-soon .section-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n}\n\n.social-connection.coming-soon .header-icon {\n    font-size: 2.5rem;\n    line-height: 1;\n}\n\n.social-connection.coming-soon .header-text h2 {\n    margin: 0 0 8px 0;\n    font-size: 1.5rem;\n    color: var(--text-primary, #1a1a1a);\n}\n\n.social-connection.coming-soon .header-text .description {\n    margin: 0;\n    color: var(--text-secondary, #666);\n    font-size: 0.95rem;\n}\n\n.coming-soon-badge {\n    position: absolute;\n    top: 24px;\n    right: 24px;\n    background: var(--bg-tertiary, #e5e7eb);\n    color: var(--text-secondary, #666);\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 0.85rem;\n    font-weight: 500;\n}\n\n/* No access fallback */\n.social-no-access {\n    grid-column: 1 / -1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    padding: 48px 24px;\n    background: #f8fafc;\n    border: 1px dashed #cbd5e1;\n    border-radius: 12px;\n    text-align: center;\n}\n\n.social-no-access-icon {\n    font-size: 2.4rem;\n}\n\n.social-no-access p {\n    margin: 0;\n    color: #64748b;\n    font-size: 0.95rem;\n    max-width: 420px;\n    line-height: 1.5;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .social-settings-container {\n        padding: 16px;\n    }\n\n    .social-settings-container h1 {\n        font-size: 1.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
